<template>
    <v-icon v-if="paymentCode === 1">fal fa-credit-card</v-icon>
    <v-icon v-else-if="paymentCode === 2">fal fa-ad</v-icon>
    <v-icon v-else-if="paymentCode === 3">fal fa-ad</v-icon>
</template>

<script>
    export default {
        name: "OrdersPayment",
        props: {
            paymentCode: Number
        },
    }
</script>

<style scoped>

</style>